import { fetchBaseQuery } from '@reduxjs/toolkit/dist/query'
import { ENV, dotenv } from 'config/dotenv.config'

export const rtkBaseQuery = fetchBaseQuery({
    baseUrl: dotenv.get(ENV.API_URL),
})

export const revalidateSeconds = Number(dotenv.get(ENV.REVALIDATE_SECONDS))
export const revalidateMiliseconds = revalidateSeconds * 1000
